import {
    trigger, state, style, transition, animate, AnimationTriggerMetadata
} from "@angular/animations";

export const fadeSlideAnimation: AnimationTriggerMetadata = trigger("fadeSlideAnimation", [
    // Standard use
    state("*", style({
        maxHeight: "500px",
        opacity: 1.0
    })),
    state("shown", style({
        maxHeight: "500px",
        opacity: 1.0
    })),
    state("hidden", style({
        maxHeight: "0px",
        opacity: 0.0,
        overflow: "hidden"
    })),
    transition("shown <=> hidden",
        animate("500ms ease")),
    // For use with ngIf
    transition(":enter", [
        style({
            maxHeight: "0px",
            opacity: 0.0,
            overflow: "hidden"
        }),
        animate("500ms", style({
            maxHeight: "500px",
            opacity: 1.0
        }))
    ]),
    transition(":leave", [
        style({
            maxHeight: "500px",
            opacity: 1.0
        }),
        animate("500ms", style({
            maxHeight: "0px",
            opacity: 0.0,
            overflow: "hidden"
        }))
    ])
]);
